import React, { FC } from 'react';
import Button from '../../components/Button';

/**
 * @deprecated Use Button instead
 */
export const ButtonBase: FC<React.ComponentPropsWithRef<typeof Button>> = ({ children, ...props }) => {
  return <Button {...props}>{children}</Button>;
};
